import { t } from "i18next";
import { useRef, useState } from "react";

import indicatorIcon from "../../assets/img/Sidebar/sidebar-arrow-down.svg";
import {
  ClearButton,
  CommonFilterDropdownTrigger,
  DropdownIndicatorIcon,
  FilterLabel,
  FilterTextWrapper,
  InputWithLabelSection,
} from "../../styledComponents/common";
import GenericPopoverModal from "./GenericPopOverModal";

const CommonFilterNew = ({
  children,
  count,
  labelName,
  clearAll,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  return (
    <>
      <InputWithLabelSection>
        <FilterLabel>{t(labelName)}</FilterLabel>

        <CommonFilterDropdownTrigger
          ref={buttonRef}
          isOpen={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        >
          <FilterTextWrapper>
            <span>{count === 0 ? "(All)" : `(${count} selected)`}</span>
            {count > 0 && (
              <ClearButton
                onClick={e => {
                  e.stopPropagation();
                  clearAll();
                }}
              >
                ×
              </ClearButton>
            )}
          </FilterTextWrapper>
          <DropdownIndicatorIcon src={indicatorIcon} alt="" isOpen={isOpen} />
        </CommonFilterDropdownTrigger>
      </InputWithLabelSection>

      <GenericPopoverModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        anchorRef={buttonRef}
        width="280px"
      >
        {children}
      </GenericPopoverModal>
    </>
  );
};

export default CommonFilterNew;
